module.exports = __webpack_public_path__ + "static/media/modal-bg@2x.a6730b50.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/modal-bg@2x.png
// module id = 1014
// module chunks = 0